// Display Fields
const image = 'image';
const richText = 'richText';
const file = 'file';

// Data Fields
const text = 'text';
const textarea = 'textarea';
const number = 'number';
const dropdown = 'dropdown';
const multiSelect = 'multiSelect';
const date = 'date';
const signature = 'signature';
const table = 'table';
const chart = 'chart';
const collection = 'collection';
const block = 'block';
const rte = 'rte';
const pricingTable = 'pricingTable';

const types = {
  image,
  file,
  richText,
  text,
  textarea,
  number,
  date,
  signature,
  table,
  chart,
  multiSelect,
  dropdown,
  block,
  collection,
  rte,
  pricingTable,
};

types.all = Object.keys(types);

export default types;
